import {NgModule} from '@angular/core';
import {PublicLayoutComponent} from './public-layout.component';
import {RouterModule} from '@angular/router';
import {PublicLayoutHeaderComponent} from './public-layout-header/public-layout-header.component';
import {PublicLayoutFooterComponent} from './public-layout-footer/public-layout-footer.component';
import {SharedModule} from '../../shared.module';
import {AuthenticationComponent} from '../../../feature-module/authentication/authentication.component';
import {AuthenticationModule} from '../../../feature-module/authentication/authentication.module';
import { AccountModule } from '../../../feature-module/store/account/account.module'
import { AddAddressComponent } from '../../../feature-module/store/account/add-address/add-address.component'
import { DealsService } from '../../service/deals/deals.service';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    AuthenticationModule,
    AccountModule
  ],
  declarations: [PublicLayoutComponent, PublicLayoutHeaderComponent, PublicLayoutFooterComponent, AuthenticationComponent, AddAddressComponent],
  entryComponents: [AuthenticationComponent],
  providers: [DealsService]
})
export class PublicLayoutModule { }
